const STORAGE_KEY = "seen-banner-modals";

const readSeenIds = (): string[] => {
  try {
    const parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) ?? "[]");
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const hasSeenBannerModal = (id: string): boolean =>
  readSeenIds().includes(id);

export const markBannerModalSeen = (id: string): void => {
  try {
    const seenIds = readSeenIds();
    if (!seenIds.includes(id)) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify([...seenIds, id]));
    }
  } catch {
    // localStorage unavailable (private browsing, blocked storage, etc.) -
    // the modal just shows again next time
  }
};
